import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=297b6704&scoped=true&"
import script from "./TitleHeader.vue?vue&type=script&lang=js&"
export * from "./TitleHeader.vue?vue&type=script&lang=js&"
import style0 from "./TitleHeader.vue?vue&type=style&index=0&id=297b6704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b6704",
  null
  
)

export default component.exports